import * as yup from 'yup';

import { SettingsFormFields } from '../types';

export const employeeSettingsFormValidationSchema = yup.object({
  [SettingsFormFields.signUpMethod]: yup.string().required(),
});
